import React, { useState } from 'react';
import '../WebflowCss/ark-payment.webflow.css';
import Calculator from '../assets/images/icon-calculator.svg';
import { RoundButton } from './Common';

export const CalculatorSection = () => {
  const [saveTime, setSaveTime] = useState('try yourself');
  const [input, setInput] = useState(0);
  const [select, setSelect] = useState(0);

  const calculate = () => {
    let time = input * select;
    setSaveTime(`${time} minutes`);
  };

  return (
    <div className="calculator-section">
      <div className="presenter-container">
        <div className="shadow-box vertical">
          <img src={Calculator} loading="lazy" alt="" className="calculator-image" />
          <div className="text-block-90">Calculate your savings</div>
          <div className="split-container">
            <div className="shadow-con-left">
              <div className="w-form">
                <input
                  className="shadow-box-input w-input"
                  name="customerCount"
                  data-name="customerCount"
                  placeholder="Your daily number of customers"
                  id="customerCount"
                  type="number"
                  onChange={(event) => setInput(parseInt(event.target.value))}
                />
                <select id="field" name="field" className="shadow-box-select w-select" onChange={(event) => setSelect(parseInt(event.target.value))}>
                  <option value={0}>Your current payment provider</option>
                  <option value={10}>MasterCard</option>
                  <option value={20}>Visa</option>
                  <option value={999}>Raifeisenbank</option>
                </select>
                <RoundButton text="Calculate" onClick={calculate} />
                <div className="success-message w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div className="error-message w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div>
            </div>
            <div className="calculator-save-group">
              <div className="text-block-25 calculator">You save</div>
              <div className="text-box-calculator">{saveTime}</div>
              <div className="text-block-25 calculator">of your customers time</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
